<template>
    <div>
        <v-btn :color="isApiKeyValid ? 'success' : 'error'"
               :loading="isApiKeyVerifying" @click="dialog = true"
               icon v-bind:class="{'shaken': shakeKey}">
            <v-icon>mdi-key</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" width="500">
            <v-card>
                <v-card-title class="grey lighten-2" primary-title>Clé d'API</v-card-title>
                <v-container>
                    <span>Insérez ici la clé d'API qui permet de vous identifier auprès du serveur</span>
                    <form @submit.prevent="validateApiKeyDialog">
                        <v-text-field placeholder="API Key" prepend-icon="mdi-key" v-model="givenApiKey"/>
                    </form>
                </v-container>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn @click="validateApiKeyDialog" color="primary" text>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

	import {mapState} from 'vuex'

	export default {
		name: "ApiKeyToolbarButton",
		data: () => ({
			dialog: false,
			givenApiKey: null,
			shakeKey: false
		}),
		computed: mapState({
			apiKey: state => state.apiKey,
			isApiKeyValid: state => state.isApiKeyValid,
			isApiKeyVerifying: state => state.isApiKeyVerifying,
		}),
		watch: {
			isApiKeyVerifying(newVal) {
				if (newVal === false) {
					if (this.isApiKeyValid === false) {
						this.shakeKey = true;
						this.givenApiKey = null;
					} else {
						this.givenApiKey = this.apiKey;
					}
				} else {
					this.shakeKey = false;
				}
			}
		},
		methods: {
			validateApiKeyDialog() {
				this.$store.dispatch("tryApiKey", this.givenApiKey);
				this.dialog = false;
			}
		}
	}
</script>

<style scoped>

    .shaken {
        animation: shake 1s linear 1;
    }

    @keyframes shake {
        10%, 90% {
            transform: translate3d(-1px, 0, 0);
        }

        20%, 80% {
            transform: translate3d(2px, 0, 0);
        }

        30%, 50%, 70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%, 60% {
            transform: translate3d(4px, 0, 0);
        }
    }

</style>
